import Switch from "@mui/material/Switch";

export default function StatusSwitch(props) {
  const { handleChange, checked, disabled } = props;
  return (
    <Switch
      value="checkedA"
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      inputProps={{ "aria-label": "secondary checkbox" }}
    />
  );
}
